import { MasterDataConstants } from "../constants";

export const masterData = (state = {}, action) => {
    switch (action.type) {
        case MasterDataConstants.GETDEPARTMENT_REQUEST:
            return {
                ...state,
            };
        case MasterDataConstants.GETDEPARTMENT_SUCCESS:
            return {
                ...state,
                department: action.department,
            };
        case MasterDataConstants.GETDEPARTMENT_FAILURE:
            return {
                ...state,
                error: action.error,
            };
        case MasterDataConstants.GETDEPARTMENTBYDESIGNATION_REQUEST:
            return {
                ...state,
            };
        case MasterDataConstants.GETDEPARTMENTBYDESIGNATION_SUCCESS:
            return {
                ...state,
                designation: action.designation,
            };
        case MasterDataConstants.GETDEPARTMENTBYDESIGNATION_FAILURE:
            return {
                ...state,
                error: action.error,
            };
        case MasterDataConstants.GETDESIGNATION_REQUEST:
            return {
                ...state,
            };
        case MasterDataConstants.GETDESIGNATION_SUCCESS:
            return {
                ...state,
                designationData: action.designation,
            };
        case MasterDataConstants.GETDESIGNATION_FAILURE:
            return {
                ...state,
                error: action.error,
            };
        case MasterDataConstants.GETSKILLS_REQUEST:
            return {
                ...state,
            };
        case MasterDataConstants.GETSKILLS_SUCCESS:
            return {
                ...state,
                skills: action.skills,
            };
        case MasterDataConstants.GETSKILLS_FAILURE:
            return {
                ...state,
                error: action.error,
            };
        case MasterDataConstants.CREATEMASTERDATA_REQUEST:
            return {
                ...state,
            };
        case MasterDataConstants.CREATEMASTERDATA_SUCCESS:
            return {
                ...state
            };
        case MasterDataConstants.CREATEMASTERDATA_FAILURE:
            return {
                ...state,
                error: action.error,
            };
        case MasterDataConstants.UPDATEMASTERDATA_REQUEST:
            return {
                ...state,
            };
        case MasterDataConstants.UPDATEMASTERDATA_SUCCESS:
            return {
                ...state
            };
        case MasterDataConstants.UPDATEMASTERDATA_FAILURE:
            return {
                ...state,
                error: action.error,
            };
        case MasterDataConstants.DELETEDEPARTMENT_REQUEST:
            return {
                ...state,
            };
        case MasterDataConstants.DELETEDEPARTMENT_SUCCESS:
            return {
                ...state
            };
        case MasterDataConstants.DELETEDEPARTMENT_FAILURE:
            return {
                ...state,
                error: action.error,
            };

        case MasterDataConstants.DELETEMASTERDATA_REQUEST:
            return {
                ...state,
            };
        case MasterDataConstants.DELETEMASTERDATA_SUCCESS:
            return {
                ...state
            };
        case MasterDataConstants.DELETEMASTERDATA_FAILURE:
            return {
                ...state,
                error: action.error,
            };

        default:
            return state;
    }
};
